import(/* webpackMode: "eager" */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/public/images/heros/header-payhawk-desktop.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/components/RequestDemo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/sections/BoostingBottomLine.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/sections/PayhawkCaseStudyStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/sections/PayhawkChallenge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/sections/PayhawkCustomerQuote2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/sections/PayhawkCustomerQuote3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/sections/PayhawkCustomerQuote4.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/apps/lune-dot-co/src/sections/PayhawkSolution.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/node_modules/@mui/material/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/lune-fe/lune-fe/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/lune-fe/lune-fe/node_modules/next/dist/client/image-component.js");
